import axios from "axios";
import config from "@/config";

import {
  getAuthToken,
  getRefreshToken,
  logout,
  atualizaTokens,
} from "./security";

const erudio = axios.create({
  baseURL: config.baseURLErudio,
  timeout: 90000,
});

const rotasPublicas = /\/tokens$|\/refresh-token$/;

async function renovarTokenErudio() {
  const refreshToken = getRefreshToken("erudio");

  if (!refreshToken) {
    throw new Error("Refresh token não encontrado");
  }

  const { data } = await axios.get(`${config.baseURLErudio}/refresh-token`, {
    headers: {
      "JWT-Authorization": `Bearer ${refreshToken}`,
    },
  });

  atualizaTokens(data, "erudio");
  return data.token;
}

erudio.interceptors.request.use((config) => {
  config.headers["JWT-Authorization"] = getAuthToken("erudio");
  return config;
});

erudio.interceptors.response.use(
  ({ data }) => data,
  async (error) => {
    const originalRequest = error.config;
    const status = error?.response?.status;
    const url = originalRequest?.url ?? "";

    if (
      status === 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !rotasPublicas.test(url)
    ) {
      originalRequest._retry = true;

      try {
        const token = await renovarTokenErudio();
        originalRequest.headers["JWT-Authorization"] = `Bearer ${token}`;
        return erudio(originalRequest);
      } catch (refreshError) {
        logout();
        return Promise.reject(refreshError);
      }
    }

    const message =
      error?.response?.data?.error?.message ??
      error?.response?.data?.message ??
      error?.message ??
      "Erro desconhecido";

    if (message.includes("Token")) {
      logout();
    }

    throw new Error(message);
  }
);

export default erudio;
